<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M7.51,788.4c1.65,0,2.99-1.32,2.99-2.95l0,0c0-1.63-1.34-2.95-2.99-2.95l0,0c-1.65,0-2.99,1.32-2.99,2.95l0,0
	C4.52,787.08,5.86,788.4,7.51,788.4L7.51,788.4z M-6.51,802.5c1.65,0,2.99-1.32,2.99-2.95l0,0c0-1.63-1.34-2.95-2.99-2.95l0,0
	c-1.65,0-2.99,1.32-2.99,2.95l0,0C-9.5,801.18-8.16,802.5-6.51,802.5L-6.51,802.5z M0.57,795.42c1.65,0,2.99-1.32,2.99-2.95l0,0
	c0-1.63-1.34-2.95-2.99-2.95l0,0c-1.65,0-2.99,1.32-2.99,2.95l0,0C-2.42,794.1-1.08,795.42,0.57,795.42L0.57,795.42L0.57,795.42z"/>
</svg>

</template>